import { OrganizationApiKeyRepository } from '@domain/organization-api-key/repositories/organization-api-key.repository';
import { OrganizationApiKeyRepositoryService } from '../repositories/organization-api-key.service';

export const OrganizationApiKeyProvider = [
  {
    provide: OrganizationApiKeyRepository,
    useClass: OrganizationApiKeyRepositoryService,
  },
];
